let appData;

export const getPath = path => name => path.replace('%root%', process.env.REACT_APP_ROOT_URL).replace('%name%', name);

export const loadAppData = function (url) {
  return new Promise((resolve,reject) => {
    fetch(url)
      .then(response => {
        const contentType = response.headers.get("content-type");
        if(contentType && contentType.includes("application/json")) {
          return response.json();
        }
        throw new TypeError("Oops, we haven't got JSON at : " + url);
      })
      .then(json => {
        appData=json; 
        resolve(json)
      })
      .catch(error => reject(error))
  });
}

export const sceneDataExist = id => appData && appData.scenes && appData.scenes[id];

export const getSceneModelsPath = function (id) {
  const data = appData.scenes[id];
  return Array.from(data.models, getPath(data.modelsPath));
}

export const getSceneMaterials = function (id) {
  const data = appData.scenes[id];
  return Array.from(data.materials, mat => ({name: mat.name, map: getPath(data.texturesPath)(mat.map)}));
}

export const getBookModelsPath = function () {
  const data = appData.book;
  return Array.from(data.models, getPath(data.modelsPath));
}

export const getBookMaterials = function () {
  const data = appData.book;
  return Array.from(data.materials, mat => ({name: mat.name, map: getPath(data.texturesPath)(mat.map)}));
}

export const getSceneCount = function () {
  return appData.scenes.length
}

export const getSceneCamera = function (id) {
  return {
    intro: appData.scenes[id].cameraIntro,
    action: appData.scenes[id].camera,
    outro: appData.scenes[id].cameraOutro
  };
}

export const getSceneDuration = function (id) {
  return parseFloat(appData.scenes[id].duration) * 1000;
}

export const getBookCamera = function () {
  return {
    intro: appData.book.cameraIntro,
    action: appData.book.camera,
    outro: appData.book.cameraOutro
  };
}

export const getBookDuration = function () {
  return parseFloat(appData.book.duration) * 1000;
}

export const getButtons = function () {
  return Array.from(appData.scenes, scene => scene.title);
}

export const getChapterName = function (id) {
  return appData.scenes[id].title
}

export const getActionFromId = function (id) {
  return {
    sentence: appData.scenes[id].baseline,
    words: appData.scenes[id].switch,
    type: appData.scenes[id].type,
    sprite: appData.scenes[id].sprite
  }
}

export const getSubliminalsPath = function () {
  const pathList = []
  appData.scenes.map((scene, sceneIndex) => {
    pathList[sceneIndex] = []
    for (let index = 1; index <= scene.subliminalCount; index++) {
      pathList[sceneIndex].push(`${process.env.REACT_APP_ROOT_URL}/assets/subliminal/${sceneIndex + 1}/${index}.jpg`)
    }
    return pathList[sceneIndex]
  })
  return pathList
}

export const getLocalData = function () {
  // TODO return data from local storage
}

export const pushLocalData = function () {
  // TODO push updated data to local storage
}

export const removeLocalData = function () {
  // TODO remove data on local storage
}


// WEBPACK FOOTER //
// ./src/scripts/helpers/DataHelper.js